import React, { useContext, useEffect, useState } from "react";
import "./CartPage.css";
import Navbar from "./Navbar";
import { CartContext } from "../../contexts/CartContext";
import { useNavigate } from "react-router-dom";
import { FaMinus, FaPlus, FaTrash } from "react-icons/fa";
import { MdWarningAmber } from "react-icons/md";
import { createSlug } from "../../utils/slugify";

function CartPage() {
  const navigate = useNavigate();
  const { cartItems, loading, updatingItemId, removeFromCart, addToCart, fetchCartItems } = useContext(CartContext);

  const [actionLock, setActionLock] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const isLocked = (id) => !!actionLock[id];
  const lockAction = (id) => {
    setActionLock((prev) => ({
      ...prev,
      [id]: true,
    }));
  };

  const unlockAction = (id) => {
    setActionLock((prev) => {
      const copy = { ...prev };
      delete copy[id];
      return copy;
    });
  };
  //   const disabled = isLocked(item.id);

  useEffect(() => {
    fetchCartItems();
  }, []);

  useEffect(() => {
    setSelectedItems(cartItems.map(item => item.id));
  }, [cartItems]);


  const toggleSelectItem = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id)
        ? prev.filter(itemId => itemId !== id)
        : [...prev, id]
    );
  };

  const selectedCartItems = cartItems.filter(item =>
    selectedItems.includes(item.id)
  );

  const toNumber = (val) => Number(val) || 0;




  const calculateBaseItemPrice = (item) => {
    if (!item || !item.device) return 0;

    const baseAmount = toNumber(item.device.amount);
    const discount = toNumber(item.device.discount);
    const network2gAmt = toNumber(item.device.network2gAmt);
    const network4gAmt = toNumber(item.device.network4gAmt);
    const subscriptionMonthlyAmt = toNumber(item.device.subscriptionMonthlyAmt);
    const subscriptionYearlyAmt = toNumber(item.device.subscriptionYearlyAmt);

    let price = baseAmount;

    if (discount > 0) {
      price -= (baseAmount * discount) / 100;
    }

    if (item.network === "2G") price += network2gAmt;
    if (item.network === "4G") price += network4gAmt;

    if (item.subscription === "monthly") price += subscriptionMonthlyAmt;
    if (item.subscription === "yearly") price += subscriptionYearlyAmt;

    return price;
  };

  const calculateFinalItemPrice = (item) => {

    const basePrice = calculateBaseItemPrice(item);
    const relayAmt = toNumber(item?.product?.selectedDevice?.relayAmt);

    const quantity = toNumber(item?.quantity);
    const totalAmount = toNumber(item?.totalAmount);

    const baseTotal = basePrice * quantity;
    const relaySelected = totalAmount > baseTotal;

    if (relaySelected && item?.product?.selectedDevice?.isRelay && relayAmt > 0) {
      return basePrice + relayAmt;
    }

    return basePrice;
  };

  const isRelaySelected = (item) => {

    if (!item || !item.device) return false;

    const basePrice = calculateBaseItemPrice(item);
    const quantity = toNumber(item.quantity);
    const totalAmount = toNumber(item.totalAmount);

    const baseTotal = basePrice * quantity;

    return totalAmount > baseTotal;
  };

  // const getTotalAmount = () => {
  //   return cartItems.reduce((acc, item) => acc + toNumber(item?.totalAmount), 0);
  // };

  const getTotalAmount = () => {
    return selectedCartItems.reduce(
      (acc, item) => acc + toNumber(item?.totalAmount),
      0
    );
  };

  const updateQuantity = async (itemId, change) => {
    if (isLocked(itemId)) return;

    const cartItem = cartItems.find((item) => item?.id === itemId);
    if (!cartItem) return;

    const updatedQuantity = (cartItem?.quantity || 1) + change;
    if (updatedQuantity < 1) return;

    try {
      lockAction(itemId);

      const basePrice = calculateBaseItemPrice(cartItem);
      const relayAmt = toNumber(cartItem.device.relayAmt);

      const currentTotal = toNumber(cartItem.totalAmount);
      const currentQuantity = toNumber(cartItem.quantity);

      const baseTotalForCurrentQty = basePrice * currentQuantity;
      const relaySelected = currentTotal > baseTotalForCurrentQty;

      let newTotalAmount = basePrice * updatedQuantity;

      if (relaySelected && cartItem.device.isRelay && relayAmt > 0) {
        newTotalAmount += relayAmt * updatedQuantity;
      }

      const updatedCartData = {
        ...cartItem,
        id: itemId,
        quantity: updatedQuantity,
        totalAmount: newTotalAmount,
        clientId: cartItem.client.id,
        deviceId: cartItem.device.id,
      };

      await addToCart(updatedCartData);
    } finally {
      unlockAction(itemId); // 🔓 ALWAYS RELEASE
    }
  };

  // const handleDelete = (itemId) => {
  //   removeFromCart(itemId);
  // };

  const handleDelete = async (itemId) => {
    if (isLocked(itemId)) return;

    try {
      lockAction(itemId);

      await removeFromCart(itemId);
    } finally {
      unlockAction(itemId);
    }
  };

  const handleWhatsAppOrder = () => {

    const phoneNumber = "917032213434"; // your WhatsApp number

    if (!cartItems || cartItems.length === 0) return;

    let message = `🛒 *New Order Request*\n\nItems:\n\n`;

    selectedCartItems.forEach((item, index) => {

      const price = toNumber(item.totalAmount);

      message += `${index + 1}️⃣ ${item.device.name}\n`;
      message += `Qty: ${item.quantity}\n`;

      if (item.network) {
        message += `Network: ${item.network}\n`;
      }

      if (item.subscription) {
        message += `Subscription: ${item.subscription}\n`;
      }

      message += `Price: ₹${price}\n\n`;
    });

    message += `-------------------------\n`;
    message += `Total Amount: ₹${getTotalAmount()}\n`;
    message += `-------------------------\n\n`;

    message += `Customer Details:\n`;
    message += `Name:\n`;
    message += `Phone:\n`;
    message += `Delivery Address:\n`;
    message += `City:\n`;
    message += `State:\n\n`;

    message += `Please confirm this order.`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  const totalAmount = getTotalAmount();

  const totalItems = selectedCartItems.reduce(
    (acc, item) => acc + (item.quantity || 0),
    0
  );

  const minAmount = 3000;
  const minItems = 1;

  const remainingAmount = Math.round(Math.max(minAmount - totalAmount, 0) * 100) / 100;
  const remainingItems = Math.max(minItems - totalItems, 0);

  const isFreeShippingEligible =
    totalAmount >= minAmount && totalItems >= minItems;

  // progress (for UI bar)
  const progressPercent = Math.min(
    (totalAmount / minAmount) * 100,
    100
  );

  if (loading && cartItems.length === 0) {
    return (
      <div className="cart-loader-full">
        <div className="spinner"></div>
        <p>Loading cart...</p>
      </div>
    );
  }

  return (

    <div className="cart-page-wrapper">

      {/* <Navbar /> */}

      {cartItems.length === 0 ? (

        <div className="cart-page-empty-wrapper">

          <div className="cart-page-empty">
            <div className="empty-icon">🛒</div>

            <h2>Your cart is empty</h2>

            <button
              className="cart-page-shop-btn"
              onClick={() => navigate("/products")}
            >
              Continue Shopping
            </button>

          </div>

        </div>

      ) : (

        <div className="cart-page-container">

          {/* CART ITEMS */}

          <div className="cart-page-items-section">

            <div className="cart-page-header">

              <h2>Your Cart</h2>
              <span className="cart-page-items-count">
                {cartItems.length} items
              </span>

            </div>

            {cartItems.map((item) => {

              if (!item || !item.device) return null;

              const relaySelected = isRelaySelected(item);
              const itemPrice = calculateFinalItemPrice(item);
              const totalPrice = toNumber(item?.totalAmount);
              const disabled = isLocked(item.id);

              return (

                <div
                  className="cart-page-item-card"
                  key={item.id}

                >

                  <div className="cart-page-select-box">
                    <input
                      type="checkbox"
                      checked={selectedItems.includes(item.id)}
                      onChange={() => toggleSelectItem(item.id)}
                    />
                  </div>

                  <div className="cart-page-item-image">

                    <img
                      src={
                        item?.device?.image?.[0] ||
                        "/images/placeholder-product.png"
                      }
                      alt={item?.device?.name}
                      className="cart-page-cart-image"
                    />

                  </div>

                  <div className="cart-page-item-content">

                    <div className="cart-page-item-header">

                      <h3
                        onClick={() => {
                          const slug = createSlug(item.device.name || item.device.webProductName);
                          navigate(`/products/${slug}`)
                        }}
                        className="cart-page-product-name">
                        {item?.device.name}
                      </h3>

                      <div className="cart-page-item-price">
                        {isLocked(item.id) ? (
                          "..."
                        ) : (
                          <>₹{totalPrice.toFixed(2)}</>
                        )}
                      </div>
                    </div>

                    <div className="cart-page-badges">

                      {item.device.isRelay && item.device.relayAmt > 0 && (
                        <span className="cart-page-badge">
                          ⚡ {relaySelected ? "Relay Included" : "No Relay"}
                        </span>
                      )}

                      {item.device.isNetwork &&
                        (item.device.network2gAmt > 0 || item.device.network4gAmt > 0) && (
                          <span className="cart-page-badge">
                            📶 {item.network || "Network not selected"}
                          </span>
                        )}

                      {item.device.isSubscription &&
                        (item.device.subscriptionMonthlyAmt > 0 ||
                          item.device.subscriptionYearlyAmt > 0) && (
                          <span className="cart-page-badge">
                            🔄 {item.subscription || "No Subscription"}
                          </span>
                        )}

                      {item?.state && item?.city && (
                        <span className="cart-page-badge cart-page-location-badge">
                          📍 {item.city}, {item.state}
                        </span>
                      )}

                    </div>

                    <div className="cart-page-details">

                      <span>Unit Price: ₹{item.unitPrice}</span>
                      <span>Qty: {isLocked(item.id) ? "..." : item.quantity}</span>

                    </div>

                    <div className="cart-page-actions">

                      <div className="cart-page-qty-controls">

                        <button
                          disabled={disabled}
                          className="cart-page-qty-btn"
                          onClick={() => updateQuantity(item.id, -1)}
                        >
                          {updatingItemId === item.id ? "..." : <FaMinus className="cart-page-qty-btn-icon" />}
                        </button>

                        {/* <span className="cart-page-qty-value">
                          {item.quantity}
                        </span> */}

                        <span className="cart-page-qty-value">
                          {isLocked(item.id) ? "..." : item.quantity}
                        </span>

                        <button
                          disabled={disabled}
                          className="cart-page-qty-btn"
                          onClick={() => updateQuantity(item.id, 1)}
                        >
                          {updatingItemId === item.id ? "..." : <FaPlus className="cart-page-qty-btn-icon" />}
                        </button>

                      </div>

                      <button
                        disabled={disabled}
                        className="cart-page-delete-btn"
                        onClick={() => handleDelete(item.id)}
                      >
                        {updatingItemId === item.id ? "Deleting..." : <FaTrash />}
                      </button>

                    </div>

                  </div>

                </div>

              );

            })}

          </div>

          {/* SUMMARY */}

          <div>
            <div className="cart-shipping-card">

              <div className="cart-shipping-header">
                <span className="shipping-title">Shipping Benefits</span>

                {isFreeShippingEligible && (
                  <span className="shipping-badge">
                    FREE SHIPPING UNLOCKED
                  </span>
                )}
              </div>

              {/* Progress Bar */}
              <div className="shipping-progress-wrapper">
                <div
                  className="shipping-progress-bar"
                  style={{ width: `${progressPercent}%` }}
                />
              </div>

              {/* Dynamic Message */}
              <div className="shipping-message">

                {isFreeShippingEligible ? (
                  <p className="success-msg">
                    You are eligible for <strong>Free Shipping</strong>
                  </p>
                ) : (
                  <p className="info-msg">

                    {remainingAmount > 0 && (
                      <>
                        Add <strong>₹{remainingAmount}</strong>
                      </>
                    )}

                    {remainingAmount > 0 && remainingItems > 0 && " and "}

                    {remainingItems > 0 && (
                      <>
                        <strong>{remainingItems} more item{remainingItems > 1 ? "s" : ""}</strong>
                      </>
                    )}

                    {" "}to unlock <strong>Free Shipping</strong>
                  </p>
                )}

              </div>

            </div>

            <div className="cart-page-summary">


              <h2 className="cart-page-summary-title">
                Order Summary
              </h2>

              {selectedCartItems.map((item) => (

                <div
                  className="cart-page-summary-item"
                  key={item.id}
                >
                  <span>
                    {item.device.name} × {item.quantity}
                  </span>

                  <span>
                    ₹{toNumber(item.totalAmount).toFixed(2)}
                  </span>
                </div>
              ))}

              <div className="cart-page-summary-total">
                <span>Total Amount: </span>
                <span>₹{getTotalAmount().toFixed(2)}</span>
              </div>

              <p className="special-cart-tax-note">
                Inclusive of all taxes
              </p>

              {/* <p className="cart-page-policy-note">
                Please review your order carefully. Cancellation is allowed only until the order is confirmed by Way4Track after payment.
              </p> */}

              <div className="cart-page-policy-box">
                <MdWarningAmber className="policy-icon" />
                <p>
                  Please review your order carefully.
                  <strong> Cancellation is allowed only until confirmation.</strong>
                  Once confirmed, the order <strong>cannot be cancelled.</strong>
                </p>
              </div>

              <button
                // disabled
                className="cart-page-checkout-btn"
                // onClick={() => navigate("/order-details")}
                onClick={() => {
                  const checkoutData = {
                    isBuyNow: false,
                    orderItems: selectedCartItems,
                    createdAt: Date.now(),
                  };

                  sessionStorage.setItem("checkout_session", JSON.stringify(checkoutData));

                  navigate("/order-details", {
                    state: checkoutData,
                  });
                }}
              >
                Proceed To Checkout(Coming Soon)
              </button>
              {/* 
              <button
                className="cart-page-whatspporder-checkout-btn"
                // onClick={() => navigate("/delivery-address")}
                onClick={handleWhatsAppOrder}
              >
                Order Via WhatsApp
              </button> */}

            </div>
          </div>

        </div>

      )}

    </div>

  );

}

export default CartPage;